<template>
  <div>
    <div class="green lighten-4">
      <v-container style="max-width: 1800px" id="overall-layout">
        <v-btn
          class="mr-2 white"
          link
          to="overview"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('project.analyse_overall') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="income_monthly"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('project.analyse_income_rent') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="income"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('project.analyse_income_total') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="product"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('project.analyse_product') }}</v-btn>
        <v-btn
          v-if="false"
          class="mr-2 white"
          link
          to="income_daily"
          active-class="white--text primary"
          outlined
          elevation="0"
          disabled
        >{{ $t('project.analyse_income_daily') }}</v-btn>
        <v-btn
          v-if="false"
          class="mr-2 white"
          link
          to="income_daily"
          active-class="white--text primary"
          outlined
          elevation="0"
          disabled
        >{{ $t('project.analyse_water_cost') }}</v-btn>
        <v-btn
          v-if="false"
          class="mr-2 white"
          link
          to="income_daily"
          active-class="white--text primary"
          outlined
          elevation="0"
          disabled
        >{{ $t('project.analyse_electricity_cost') }}</v-btn>
        <v-btn
          v-if="false"
          class="mr-2 white"
          link
          to="income_daily"
          active-class="white--text primary"
          outlined
          elevation="0"
          disabled
        >{{ $t('project.analyse_meter_renter') }}</v-btn>
      </v-container>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      countSettingTasks: "settingTask/countSettingTasks"
    })
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
</style>